import MuiListItemText, { ListItemTextProps } from "@mui/material/ListItemText";

const ListItemText: React.FC<ListItemTextProps> = MuiListItemText;

export default ListItemText;

export type { ListItemTextProps };
